import { WebPlugin } from '@capacitor/core';
export class EnrollWeb extends WebPlugin {
    async startEnroll(_options) {
        throw this.unavailable('The eNROLL plugin is not available on the web. ' +
            'Run this app on a native Android or iOS device using Capacitor.');
    }
}
//# sourceMappingURL=web.js.map